import { BaseCell, TableAvatar, TableText } from '@crehana/compass.ui/table';
import { createColumnHelper } from '@crehana/compass.ui/table/tanstack';

import { useCourseDetailTranslation } from '@/views/OrgCourseDetail/hooks/useCourseDetailTranslation';

import type { TEnrollmentsTableUserColumn } from '../../../hooks/use-enrollments-by-course/types';

const columnsHelper = createColumnHelper<TEnrollmentsTableUserColumn>();

export const useEnrollmentsTableColumns = () => {
  const { t } = useCourseDetailTranslation();

  return [
    columnsHelper.accessor('enrollment', {
      header: t('ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_NAME'),
      cell: info => {
        const enrollment = info.getValue();

        return (
          <BaseCell>
            <TableAvatar src={enrollment.avatar} />
            <TableText
              title={`${enrollment.firstName} ${enrollment.lastName}`}
              subtitle={enrollment.email}
            />
          </BaseCell>
        );
      },
    }),
    /*
    // TODO: Uncomment this when the feature is implemented in the backend
    columnsHelper.accessor('assignedRole', {
      header: t('ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_ROLE'),
      cell: info => {
        const assignedRole = info.getValue();

        return assignedRole;
      },
    }), */
  ];
};
